module.exports = __webpack_public_path__ + "static/media/badania i rozwoj.9d5d4492.svg";